import type { InlineCode } from 'mdast'
import * as React from 'react'

import { styled } from '~/styled'

type MarkdownInlineCodeProps = {
  node: InlineCode
}

const StyledMarkdownInlineCode = styled('div', {
  base: [
    'bg-grey-200',
    'rounded-sm',
    'text-grey-1000',
    'inline-block',
    'font-mono',
    'text-[85%]',
    'px-1',
    'py-0.5'
  ]
})

export const MarkdownInlineCode = ({ node }: MarkdownInlineCodeProps) => (
  <StyledMarkdownInlineCode as="code">{node.value}</StyledMarkdownInlineCode>
)
